import { bulk as bulkUpdateEvents } from '../../events/actions/update';
import { bulk as bulkUpdateMarkets } from '../../markets/actions/update';
import { update as updateCompetitionsList } from '../../competitions/actions/update-collection';
import { bulk as bulkUpdateParticipants } from '../../participants/actions/update';
import { bulk as bulkUpdateSelections } from '../../selections/actions/update';
import { bulk as bulkUpdateSports } from '../../sports/actions/update';

export function request(userId, bets, selectedLegs, channel, isFreeBet, selectedFreeBets) {
    return (dispatch, getState) => {
        dispatch({
            type: 'BETSLIP_GET_POSSIBLE_BETS_REQUEST',
            userId,
            bets,
            channel,
            selectedLegs,
            selections: getState().selections.get('items'),
            isFreeBet,
            selectedFreeBets
        });
    };
}

export function error(userId, errors) {
    return {
        type: 'BETSLIP_GET_POSSIBLE_BETS_ERROR',
        userId,
        errors
    };
}

export function finish(userId, { bets, combinations,
    errors, success, events, competitions, selections, markets, participants, bonusEngineFreeBets }) {
    return (dispatch) => {
        if (events && competitions) {
            dispatch(bulkUpdateEvents(events, competitions));
        }

        if (markets) {
            dispatch(bulkUpdateMarkets(markets));
        }

        if (participants) {
            dispatch(bulkUpdateParticipants(participants));
        }

        if (selections) {
            dispatch(bulkUpdateSelections(selections));
        }

        dispatch({
            type: 'BETSLIP_GET_POSSIBLE_BETS_FINISH',
            userId,
            combinations,
            bets,
            errors,
            success,
            bonusEngineFreeBets
        });
    };
}
